import { render, staticRenderFns } from "./KeywordDetailFooter.vue?vue&type=template&id=c8f87fd6"
import script from "./KeywordDetailFooter.vue?vue&type=script&lang=js"
export * from "./KeywordDetailFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports